<template>
  <el-table-column v-bind="column" >
    <template v-for="(item,index) in getChildren">
      <xyj-multilevel-header v-if="item.children && item.children.length" :key='item.arrange' :column="item"></xyj-multilevel-header>
      <el-table-column v-else-if="item.isAllowSearch !== 2" :key="item.id" v-bind="item" :sortable="item.sortType != 2 ? isSelfSort ? true : 'custom': false">
        <template slot-scope="scope">
          <img v-if="item.showType == 2" :src="scope.row[item.prop]" class="avatar">
          <!-- 2025-02-07 多级表格增加表格编辑功能 -->
          <!-- <span v-else v-html="item.formatter?item.formatter(scope.row,null,scope.row[item.prop]):scope.row[item.prop]"></span> -->
          <!-- <div v-else-if="item.showType == 1 && hasOperEdit && ((onpeprop == item.prop && onpeid == (item.formatter?item.formatter(scope.row,null,scope.row.id):scope.row.id)) || (item.ifEntryRequired == 1 && (scope.row[item.prop] == '' || scope.row[item.prop] == null)))"> -->
          <div v-else-if="item.showType == 1 && hasOperEdit && item.isEdit">
            <span v-if="(isred || scope.row[item.prop] == '') && item.ifEntryRequired == 1" style="color: #ff0000;">*</span>
            <el-input style="width: 100%;" :id="scope.row.id + item.prop"
					            placeholder="可编辑"
                      size="mini"
                      v-model="scope.row[item.prop]"
                      @focus="ToOperedit(scope.row[item.prop],scope.row,item,scope.index)"
                      @blur="onblur(scope.row[item.prop])">
                  </el-input>
          </div>
          <!-- <div v-else-if="item.showType == 1 && item.isEdit" @dblclick.stop="OnOperedit(scope.row,item,2,scope.index)">
            <span @click.stop="OnOperedit(scope.row,item,1,scope.index)" v-html="item.formatter?item.formatter(scope.row,null,scope.row[item.prop]):scope.row[item.prop]"></span>
          </div> -->
          <div v-else-if="item.showType == 1">
            <span v-html="item.formatter?item.formatter(scope.row,null,scope.row[item.prop]):scope.row[item.prop]"></span>
          </div>
        </template>
      </el-table-column>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    name: 'xyjMultilevelHeader',
    props: {
      column: {
        type: Object,
        default(){
          return {
            resizable: true,//对应列是否可以通过拖动改变宽度（需要在 el-table 上设置 border 属性为真）
            minWidth: '10px',//列最小宽度
            showOerflowTooltip: true, //当内容过长被隐藏时显示 tooltip
            headerAlign: 'center',//表头对齐方式，若不设置该项，则使用表格的对齐方式
            children: [], //子列头
            longText:'',//编辑字段内容（弹窗内容）
            longId:'',//编辑数据id
            longProp:'',//编辑字段名称
            longRow:'',//编辑数据
            longIndex:0,//编辑数据index
            longifEntryRequired:0,//编辑字段是否必填 1是  0否
            onpeid:'',
            onpeprop:'',
            isred:false,//当前输入框是否为红色
          }
        }
      },
      isSelfSort:{
        type:Boolean,
        default:false
      },
      /**
     * conc：20230516
     * 表格是否可直接编辑
     */
     hasOperEdit: {
      type: Boolean,
      default: false
     },
     /**
     * conc：20230516
     * 表格可编辑禁用配置
     */
    notDdit:{
      type: Array,
      default() {
        return [];
      }
    },
    },
    methods: {
      //表格可输入编辑,获取焦点时触发
      ToOperedit(val,row,item,index){
        // console.log('ToOperedit1',val)
        if(val == ''){
          this.onpeid = row.id;
          this.onpeprop = item.prop;
        }
        this.longText = val;
        this.longId = row.id;
        this.longProp = item.prop;
        this.longRow = row;
        this.longIndex = index;
        this.longifEntryRequired = item.ifEntryRequired;
        // console.log('================index',index)
      },
      //表格编辑失去焦点 文本格式
      onblur(val){
        // console.log('onblur---------',val);
        // if(val.originalTarget) this.longText = val.originalTarget.value
        this.longText = val
        // console.log('this.longText==2',this.longText)
        if(this.longifEntryRequired == 1 && (this.longText == '' || this.longText == null || this.longText == 'undefined')){
          this.$message({ type: "warning", message: '当前字段为必填字段，不能为空，否则将无法保存!' });
          this.isred = true;
          return;
        }
        this.isred = false;
        this.onpeid = '';
        this.onpeprop = '';
        this.$emit("to-opere2dit", this.longText,this.longId,this.longProp,this.longifEntryRequired);
      },
      //确认点击表格位置,通过点击定位到哪条数据的哪个字段 ctype = 1 点击表格  =2点击文字
    OnOperedit(row,item,ctype,index){
      // console.log('OnOperedit----row',row)
      // console.log('OnOperedit----item',item);
      // console.log('item.isEdit',item.isEdit);
      // console.log('notDdit',this.notDdit);
      // console.log('OnOperedit----index',index)
      if(this.isred){
        this.$message({ type: "warning", message: '请完善必填字段！' });
        return
      }
      this.longRow = row;
      this.longIndex = index;
      this.isred = false;
      let iseditfill = false;//是否禁止编辑该行数据
      for(var j = 0;j < this.notDdit.length;j++){
          // console.log('222====',this.notDdit[j].value.indexOf(row[this.notDdit[j].name]))
          if(this.notDdit[j].value.indexOf(row[this.notDdit[j].name]) != '-1'){
            iseditfill = true;
          }
      }
      // console.log('iseditfill',iseditfill)
      if(item.isEdit == '1' && !iseditfill){
        this.onpeid = row.id;
        this.onpeprop = item.prop;
        if(item.showType == 1 && this.hasOperEdit && this.onpeprop == item.prop && this.onpeid == (item.formatter?item.formatter(row,null,row.id):row.id)){
          console.log('hhhhhhhh')
        }
        console.log('id===',row.id + item.prop)
        setTimeout(() => {
          var my = document.getElementById(row.id + item.prop);
          console.log('my',my)
          my.focus();
        },100)
        if(ctype == 1){
          // console.log('点击表格')
        }else{
          // console.log('点击文字')
          // this.onpeid = '';
          // this.onpeprop = '';
          //时间选择器不放大date日期  singleDate日期时间 datePicker日期范围 年月month
          if(item.fieldType != 'date' && item.fieldType != 'singleDate' && item.fieldType != 'datePicker' && item.fieldType != 'month' && item.fieldType != 'select'){
              //表格输入框放大
              this.longText = row[item.prop];
              this.longifEntryRequired = item.ifEntryRequired;
          }
        }
      }
    },
    },
    computed:{
      getChildren(){
        return this.column.children.sort((a,b) => {
          return a.arrange-b.arrange
        })
      }
      
    }
  }
</script>

<style scoped>
.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/xyjtable/xyjMultilevelHeader.vue